export const updateJSONObj = (jsonObject, targetKey, replacementValue) => {
  return Object.assign({}, jsonObject, { [targetKey]: replacementValue });
};
